import { request } from "../../httpClient";

export const getUserDataRequest = async (id) => {
  const res = await request({
    path: `user-data/get-data?user_id=${id}`,
  });
  return res;
};
